
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";

interface ImageMetadataFieldsProps {
  altText: string;
  setAltText: (text: string) => void;
  titleText: string;
  setTitleText: (text: string) => void;
  isUploading: boolean;
}

const ImageMetadataFields: React.FC<ImageMetadataFieldsProps> = ({
  altText,
  setAltText,
  titleText,
  setTitleText,
  isUploading
}) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="alt-text" className="flex items-center text-foreground font-medium">
          Alt Text <span className="text-destructive ml-1">*</span>
        </Label>
        <Textarea
          id="alt-text"
          placeholder="Describe the image for accessibility and SEO"
          value={altText}
          onChange={(e) => setAltText(e.target.value)}
          disabled={isUploading}
          rows={2}
          className="resize-none bg-muted/30 border-2 border-border focus-visible:border-primary"
        />
        <p className="text-xs text-muted-foreground">
          A clear, concise description of the image for screen readers and search engines.
        </p>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="title-text" className="text-foreground font-medium">Title Text (optional)</Label>
        <Input
          id="title-text"
          placeholder="Title shown when hovering over the image"
          value={titleText}
          onChange={(e) => setTitleText(e.target.value)}
          disabled={isUploading}
          className="bg-muted/30 border-2 border-border focus-visible:border-primary"
        />
      </div>
    </>
  );
};

export default ImageMetadataFields;
